/**
 * JS cookie helpers
 */


/**
 * Set a cookie.
 *
 * @param	{String}	name 					(Required) Cookie name
 * @param	{String}	value					(Required) Cookie value
 * @param	{Number}	[days = 1]			    (Optional) Days from today to live for.
 */
export function set(name, value, days = 1) {
	const d = new Date();
	d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
	const expires = "expires=" + d.toUTCString();
	document.cookie = name + "=" + value + ";" + expires + ";path=/";
}


/**
 * Get a cookie.
 *
 * @param	{String}	cname	(Required) Cookie name
 * @return  {String|Boolean}    The value of the cookie if it exists. False if not
 */
export function get(cname) {
	const name = cname + "=";
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	let value = false;

	ca.forEach(c => {
		while (c.charAt(0) === ' ') c = c.substring(1);
		if (c.indexOf(name) === 0) value = c.substring(name.length, c.length);
	});

	return value;
};


export default {
	set,
	get
};